"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeFlappy = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameMode_1 = require("./CTGGameMode");
class CTGGameModeFlappy extends CTGGameMode_1.CTGGameMode {
    constructor(generator, speed) {
        super(null);
        this.generator = generator;
        this.win_on_time_out = true;
        this.speed = speed;
        this.total_rows = 5;
        this.starting_rows = 1;
        this.rows = [];
        this.row_distance = this.spacing();
        this.gravity = 60;
        this.boost = this.gravity / 2;
    }
    reset() {
        super.reset();
        this.rows = [];
        this.current_offset = 0;
        this.bird = null;
        this.bird_vel = 0;
    }
    on_start(scene, rand, difficulty) {
        super.on_start(scene, rand, difficulty);
        let total_rows = this.speed.compute_delta(this.get_time_limit(this.difficulty) / 1000, 0, this.get_time_limit(this.difficulty) / 1000, difficulty, 0) / this.spacing();
        this.generator.start(rand, total_rows);
    }
    generate_initial_cards(rand, difficulty) {
        let specs = [];
        for (let y = 0; y < this.total_rows; y++) {
            if (y >= this.total_rows - this.starting_rows) {
                let cards = this.generate_row(rand, y, difficulty);
                for (let i = 0; i < cards.length; i++) {
                    if (cards[i] == null)
                        continue;
                    specs.push(cards[i]);
                }
                this.rows.push(cards);
            }
            else {
                this.rows.push([]);
            }
        }
        this.bird = new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Diamonds, CTGCard_1.CTGRank.Two);
        this.bird.rot = 90;
        this.bird.x = this.fixed_x_position(0);
        this.bird.y = this.fixed_y_position(2);
        this.bird_vel = 0;
        specs.push(this.bird);
        return specs;
    }
    generate_row(rand, y, difficulty) {
        let row = this.generator.getRow(rand, 12);
        for (let i = 0; i < row.length; i++) {
            if (row[i] == null)
                continue;
            row[i].x = this.fixed_x_position(y);
            row[i].y = this.fixed_y_position(i / 3);
        }
        return row;
    }
    card_tapped(card) {
    }
    card_destroyed(card) {
    }
    row_off_screen(row) {
        let lose_cards = [];
        for (let card of row) {
            if (card == null)
                continue;
            if (card.destroyed)
                continue;
            if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Must) {
                lose_cards.push(card);
                continue;
            }
            card.destroy(false);
        }
        ;
        if (lose_cards.length > 0) {
            this.lose(lose_cards);
        }
    }
    cards_generated(cards) { }
    time_ran_out() {
        this.win();
    }
    add_row() {
        let row = this.generate_row(this.rand, this.rows.length, this.difficulty);
        this.rows.push(row);
        row = row.filter(x => x != null);
        this.cards_added(row, true);
        this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_ADD_CARDS, { cards: row });
    }
    clicked(scene, mx, my) {
        this.bird_vel = Math.min(0, this.bird_vel);
        this.bird_vel -= this.boost;
        scene.add_sound_to_set("sfx_destroy");
    }
    update_position(now, delta, difficulty, mx, my, mdown) {
        const delta_s = delta / 1000;
        this.bird_vel += this.gravity * delta_s * (1 + this.difficulty);
        this.bird.move(this.bird.x, this.bird.y + this.bird_vel * delta_s * (1 + this.difficulty));
    }
    update_game(scene, now, delta, difficulty, mx, my, mdown) {
        let new_time = now - this.start_time;
        const move_delta = this.speed.compute_delta(new_time / 1000, Math.max(0, new_time - delta) / 1000, delta / 1000, difficulty, this.score);
        this.current_offset += move_delta;
        if (this.current_offset > this.row_distance) {
            let row = this.rows.shift();
            this.row_off_screen(row);
            this.add_row();
            this.current_offset -= this.row_distance;
        }
        for (let i = 0; i < this.rows.length; i++) {
            let row = this.rows[i];
            let x = this.fixed_x_position(i) - this.current_offset;
            row.forEach(card => {
                if (card != null)
                    card.move(x, card.y);
            });
        }
        this.update_position(now, delta, difficulty, mx, my, mdown);
        if (this.bird.y > 64 || this.bird.y < 0) {
            this.lose([this.bird]);
        }
        let collisions = [];
        collisions.push(...this.check_for_card_collisions(this.bird, this.rows[0], 2));
        collisions.push(...this.check_for_card_collisions(this.bird, this.rows[1], 2));
        collisions.push(...this.check_for_card_collisions(this.bird, this.rows[2], 2));
        collisions.forEach(element => {
            if (element.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
                this.lose([element]);
            }
            else {
                element.destroy(true, true);
            }
        });
    }
}
exports.CTGGameModeFlappy = CTGGameModeFlappy;
